import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // oder: document.documentElement.scrollTo({ top: 0, left: 0 });
  }, [pathname]);

  return null;
}
